import Vue from 'vue';
import VueMatomo from 'vue-matomo';
import { VueMaskDirective } from 'v-mask';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

Vue.use(VueMatomo, {
  host: 'https://matomo.landrumhr.com/',
  siteId: 5,
  router,
  enableHeartBeatTimer: true,
  heartBeatTimerInterval: 15,
  requireConsent: false,
  requireCookieConsent: false,
});

Vue.directive('mask', VueMaskDirective);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
